<mat-card>
  <mat-card-title data-at-note-modal-title>
    <h2 class="header">
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.CHANGE_SORT_ORDER.MODAL_HEADER' | translate }}

      <mat-icon
        class="close-icon"
        gtm="onOpen"
        gtmAction="Dashboard create new column - close modal"
        gtmCategory="Add dashboard column"
        (click)="closeModal()"
        >close</mat-icon
      >
    </h2>
  </mat-card-title>
  <mat-card-content>
    <p>{{ '+INSTALLATIONS.KANBAN_DASHBOARD.EDIT_COLUMN.MODAL_DESCRIPTION' | translate }}</p>
    <form [formGroup]="sortOrderForm" class="form">
      <mat-form-field mat-select-height-medium>
        <mat-label>
          {{ '+INSTALLATIONS.KANBAN_DASHBOARD.CHANGE_SORT_ORDER.SORT_BY' | translate }}
        </mat-label>
        <mat-select
          formControlName="sortOrder"
          gtm="onOpen"
          gtmAction="Dashboard create new column - open order dropdown"
          gtmCategory="Add dashboard column"
          [placeholder]="
            '+INSTALLATIONS.KANBAN_DASHBOARD.CHANGE_SORT_ORDER.PLEASE_SELECT' | translate
          "
        >
          <mat-option
            *ngFor="let order of sortOrder"
            [value]="order.value"
            gtm="onSelect"
            gtmAction="Dashboard create new column - set order value"
            gtmCategory="Add dashboard column"
            >{{ order.label | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions class="buttons">
    <button
      [disabled]="sortOrderForm.invalid"
      mat-raised-button
      color="primary"
      gtm="onSave"
      gtmAction="Dashboard edit column - send request"
      gtmCategory="AdEdit dashboard column"
      (click)="setSortOrder()"
    >
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.ADD_COLUMN_MODAL.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
